// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"visually-hidden_component_visuallyHidden__kal2v"};